export default function PageHeader({ title, subtitle, badge, actions }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: 24,
    }}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          <h1 style={{
            fontSize: 'var(--font-size-2xl)',
            fontWeight: 'var(--font-weight-normal)',
            color: 'var(--color-text-primary)',
            margin: 0,
          }}>
            {title}
          </h1>
          {badge && badge}
        </div>
        {subtitle && (
          <p style={{
            fontSize: 'var(--font-size-base)',
            color: 'var(--color-text-tertiary)',
            margin: 0,
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
          {actions}
        </div>
      )}
    </div>
  );
}